import * as React from "react";
import {
    Typography,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    DialogContentText,
    Box,
    FormControlLabel,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MainInput, sec_button } from "./Styles";

function EditBrandModal({ open, handleAccept, handleClose, title, brand }) {
    console.log(brand)
    const [settings, setSettings] = React.useState({
        brandName: brand?.brandName || "",
        email: brand?.email || "",
        allowToOpenPackage: brand?.allowToOpenPackage || false,
        fragileOrders: brand?.fragileOrders || false,
        receiveOrders: brand?.receiveOrders || false,
        usesEcom: brand?.usesEcom || false,
        shippingService: brand?.shippingService || "Bosta"
    });

    // Update settings when brand changes
    React.useEffect(() => {
        if (brand) {
            setSettings({
                brandName: brand.brandName || "",
                email: brand.email || "",
                allowToOpenPackage: brand.allowToOpenPackage || false,
                fragileOrders: brand.fragileOrders || false,
                receiveOrders: brand.receiveOrders || false,
                usesEcom: brand.usesEcom || false,
                shippingService: brand.shippingService || "Bosta"
            });
        }
    }, [brand]);

    const handleChange = (event) => {
        const { name, value, checked } = event.target;
        setSettings(prev => ({
            ...prev,
            [name]: event.target.type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        handleAccept(settings);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth
            maxWidth="sm"
        >
            <DialogTitle sx={{ fontWeight: "bold" }} id="alert-dialog-title">
                {title}
            </DialogTitle>
            <Box component="form" onSubmit={handleSubmit}>
                <DialogContent>
                    <MainInput
                        margin="normal"
                        required
                        fullWidth
                        id="brandName"
                        label="Brand Name"
                        name="brandName"
                        value={settings.brandName}
                        onChange={handleChange}
                    />
                    <MainInput
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Brand Email"
                        name="email"
                        type="email"
                        value={settings.email}
                        onChange={handleChange}
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={settings.allowToOpenPackage}
                                onChange={handleChange}
                                name="allowToOpenPackage"
                            />
                        }
                        label="Allow to Open Package"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={settings.fragileOrders}
                                onChange={handleChange}
                                name="fragileOrders"
                            />
                        }
                        label="Fragile Orders"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={settings.receiveOrders}
                                onChange={handleChange}
                                name="receiveOrders"
                            />
                        }
                        label="Receive Orders"
                    />
                    <Box sx={{ mb: 1 }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={settings.usesEcom}
                                    onChange={handleChange}
                                    name="usesEcom"
                                />
                            }
                            label="Uses EcomHQ"
                        />
                        <Typography variant="caption" color="text.secondary" sx={{ display: "block", ml: 4, mt: -0.5 }}>
                            When enabled, live inventory, orders, payouts, and delivery metrics are sent to EcomHQ for this brand.
                        </Typography>
                    </Box>
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel id="shipping-service-label">Shipping Service</InputLabel>
                        <Select
                            labelId="shipping-service-label"
                            id="shippingService"
                            name="shippingService"
                            value={settings.shippingService}
                            label="Shipping Service"
                            onChange={handleChange}
                        >
                            <MenuItem value="Bosta">Bosta</MenuItem>
                            <MenuItem value="ShipBlu">ShipBlu</MenuItem>
                            <MenuItem value="Fincart">Fincart</MenuItem>
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ ...sec_button }} onClick={handleClose}>Cancel</Button>
                    <Button sx={{ ...sec_button }} type="submit">
                        Save Changes
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}

export default EditBrandModal; 